import { render, staticRenderFns } from "./ProductPropertiesAsideComponent.vue?vue&type=template&id=54afd069&scoped=true"
import script from "./ProductPropertiesAsideComponent.vue?vue&type=script&lang=js"
export * from "./ProductPropertiesAsideComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54afd069",
  null
  
)

export default component.exports